module.exports = __webpack_public_path__ + "static/media/intro.5702fc04.webp";